import { EquipmentDetailsDto } from '@festo-ax/smartenance-shared-ui';
import { ValueOf } from '../common';

export const SapConnectionStatus = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  UNKNOWN: 'unknown'
} as const;

export type SapConnectionStatus = ValueOf<typeof SapConnectionStatus>;

export class SapEquipmentMeta {
  sapEquipment: EquipmentDetailsDto | null;
  loadingSapEquipment: boolean;
  sapEquipmentLoadingHasError: boolean;
}
